import { createReducer } from '@reduxjs/toolkit';

import BookingReducer from './booking_reducer';
import AvailabilityReducer from './availability_reducer';
import ResourcesReducer from './resources_reducer';
import CheckoutReducer from './checkout_reducer';
import VehicleLinkReducer from './vehicle_link_reducer';
import ServicesReducer from './services_reducer';
import UIReducer from './ui';
import UserReducer from './user_reducer/user_reducer';
import TypesReducer from './types_reducer';

const reducers = {
  booking: BookingReducer,
  types: TypesReducer,
  resources: ResourcesReducer,
  user: UserReducer,
  availability: AvailabilityReducer,
  vehicleLink: VehicleLinkReducer,
  product_page_id: createReducer(
    window.ecom.redux_initial_state.product_page_id,
    {}
  ),
  checkout: CheckoutReducer,
  countries: createReducer(window.ecom.redux_initial_state.countries || {}, {}),
  regions: createReducer(window.ecom.redux_initial_state.regions || {}, {}),
  locations: createReducer(window.ecom.redux_initial_state.locations || {}, {}),
  ui: UIReducer,
  jackson: createReducer(window.ecom.redux_initial_state.jackson || {}, {}),
  services: ServicesReducer,
  sealink: createReducer(window.ecom.redux_initial_state.sealink || {}, {}),
  routes: createReducer(window.ecom.redux_initial_state.routes || {}, {}),
};

export default reducers;
